function skeletize(el: HTMLElement | string) {
    if (typeof el === 'string') {
        el = document.querySelector(el) as HTMLElement;
    }

    document.body.classList.add('skeleton');

    let textElements = 0;
    let images = 0;
    let backgrounds = 0;

    /**
     * text elements:
     * all elements which directly contain text nodes
     * move text to data attribute, remove text content and add skeleton class
     */
    Array.from(el.querySelectorAll('*'))
        .filter((x) =>
            Array.from(x.childNodes).some(
                (z) => z.nodeName === '#text' && z.textContent.trim().length
            )
        )
        .filter((x) => x.textContent.length)
        .forEach((x) => {
            x.setAttribute('data-skeleton', x.textContent);
            x.textContent = '';
            x.classList.add('skeleton-text');
            textElements++;
        });

    /**
     * backgrounds:
     * replace all background classes that are not white
     */
    Array.from(el.querySelectorAll("*[class^='bg-'], *[class*=' bg-']"))
        .filter((x) => !x.classList.contains('bg-white'))
        .forEach((x) => {
            x.classList.add('skeleton-bg-dark');
            backgrounds++;
        });

    /**
     * images and svgs:
     * replace img/svg with divs and add skeleton class
     */
    Array.from(el.querySelectorAll('img,svg')).forEach((x) => {
        const replacement = document.createElement('div');
        replacement.classList.add(...x.classList, 'skeleton-image');
        x.replaceWith(replacement);
        images++;
    });

    console.log(
        `changed ${textElements} text elements, ${images} images and ${backgrounds} backgorunds`
    );
}

export default skeletize;
